import { startsWith } from "util/string-utils";

export const isGrn = function (encodeSource = ``) {
    return startsWith(encodeSource, `grn:`);
};

export const isUrl = function (encodeSource = ``) {
    return startsWith(encodeSource, `url:`);
};

export const getGrnString = function (hash?: string, range?: number | string) {
    if (hash === undefined) {
        return;
    }

    let grnString = `grn:`;
    grnString += `${hash}:`;

    if (range !== undefined) {
        grnString += `${range}`;
    }

    return grnString;
};
